// extracted by mini-css-extract-plugin
export default {"container":"A0-z","heading":"B0-z","links":"C0-z","copy":"D0-z","subCopy":"E0-z","linksLeft":"F0-z","linksCenter":"G0-z","linksRight":"H0-z","link":"I0-z","onlyLink":"J0-z"};